import { inject, NgModule } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

import { SvgIconDefinition } from '@models';

export const iconDefinitions: SvgIconDefinition[] = [
  { name: 'home', url: 'assets/ui-lib/icons/home.svg' },
  { name: 'home-outline', url: 'assets/ui-lib/icons/home-outline.svg' },
  { name: 'calendar-month', url: 'assets/ui-lib/icons/calendar-month.svg' },
  {
    name: 'calendar-month-outline',
    url: 'assets/ui-lib/icons/calendar-month-outline.svg',
  },
  { name: 'clipboard-list', url: 'assets/ui-lib/icons/clipboard-list.svg' },
  {
    name: 'clipboard-list-outline',
    url: 'assets/ui-lib/icons/clipboard-list-outline.svg',
  },
  { name: 'drug-herb', url: 'assets/ui-lib/icons/drug-herb.svg' },
  { name: 'education', url: 'assets/ui-lib/icons/education.svg' },
  { name: 'messages', url: 'assets/ui-lib/icons/messages.svg' },
  { name: 'users-group', url: 'assets/ui-lib/icons/users-group.svg' },
  { name: 'book', url: 'assets/ui-lib/icons/book.svg' },
  { name: 'chart-pie', url: 'assets/ui-lib/icons/chart-pie.svg' },
  { name: 'inbox-full', url: 'assets/ui-lib/icons/inbox-full.svg' },
  {
    name: 'brand-google-logo',
    url: 'assets/ui-lib/icons/brand-google-logo.svg',
    colorMode: 'fixed',
  },
  {
    name: 'brand-outlook-logo',
    url: 'assets/ui-lib/icons/brand-outlook-logo.svg',
    colorMode: 'fixed',
  },
  {
    name: 'brand-zoom-logo',
    url: 'assets/ui-lib/icons/brand-zoom-logo.svg',
    colorMode: 'fixed',
  },
  {
    name: 'brand-fullscript-logo',
    url: 'assets/ui-lib/icons/brand-fullscript-logo.svg',
    colorMode: 'fixed',
  },
  { name: 'wallet', url: 'assets/ui-lib/icons/wallet.svg' },
  { name: 'life-saver', url: 'assets/ui-lib/icons/life-saver.svg' },
  {
    name: 'lightbulb',
    url: 'assets/ui-lib/icons/lightbulb.svg',
  },
  { name: 'trash-outline', url: 'assets/ui-lib/icons/trash-outline.svg' },
  { name: 'image-outline', url: 'assets/ui-lib/icons/image-outline.svg' },
  { name: 'globe', url: 'assets/ui-lib/icons/globe.svg' },
  {
    name: 'badge-check-outline',
    url: 'assets/ui-lib/icons/badge-check-outline.svg',
  },
  {
    name: 'membership-outline',
    url: 'assets/ui-lib/icons/membership-outline.svg',
  },
  { name: 'upload-outline', url: 'assets/ui-lib/icons/upload-outline.svg' },
  { name: 'eye-outline', url: 'assets/ui-lib/icons/eye-outline.svg' },
  { name: 'send-horizontal', url: 'assets/ui-lib/icons/send-horizontal.svg' },
  { name: 'send', url: 'assets/ui-lib/icons/send.svg' },
  { name: 'external-link', url: 'assets/ui-lib/icons/external-link.svg' },
  { name: 'edit-outline', url: 'assets/ui-lib/icons/edit-outline.svg' },
  { name: 'ban', url: 'assets/ui-lib/icons/ban.svg' },
  {
    name: 'file-check-outline',
    url: 'assets/ui-lib/icons/file-check-outline.svg',
  },
  {
    name: 'chart-mixed',
    url: 'assets/ui-lib/icons/chart-mixed.svg',
  },
  {
    name: 'arrow-up-down',
    url: 'assets/ui-lib/icons/arrow-up-down.svg',
  },
  {
    name: 'arrow-down',
    url: 'assets/ui-lib/icons/arrow-down.svg',
  },
  {
    name: 'arrow-left',
    url: 'assets/ui-lib/icons/arrow-left.svg',
  },
  {
    name: 'symptom-arrow-up',
    url: 'assets/ui-lib/icons/symptom-arrow-up.svg',
  },
  {
    name: 'symptom-arrow-down',
    url: 'assets/ui-lib/icons/symptom-arrow-down.svg',
  },
  {
    name: 'arrow-up',
    url: 'assets/ui-lib/icons/arrow-up.svg',
  },
  {
    name: 'arrow-right',
    url: 'assets/ui-lib/icons/arrow-right.svg',
  },
  {
    name: 'envelope-outline',
    url: 'assets/ui-lib/icons/envelope-outline.svg',
  },
  {
    name: 'plus',
    url: 'assets/ui-lib/icons/plus.svg',
  },
  {
    name: 'clock-outline',
    url: 'assets/ui-lib/icons/clock-outline.svg',
  },
  {
    name: 'sticky-note',
    url: 'assets/ui-lib/icons/sticky-note.svg',
  },
  {
    name: 'coin',
    url: 'assets/ui-lib/icons/coin.svg',
  },
  {
    name: 'location',
    url: 'assets/ui-lib/icons/location.svg',
  },
  {
    name: 'edit-linear',
    url: 'assets/ui-lib/icons/edit-linear.svg',
  },
  {
    name: 'file-copy-alt',
    url: 'assets/ui-lib/icons/file-copy-alt.svg',
  },
  {
    name: 'exclamation-outline',
    url: 'assets/ui-lib/icons/exclamation-outline.svg',
  },
  {
    name: 'exclamation-circle',
    url: 'assets/ui-lib/icons/exclamation-circle.svg',
  },
  {
    name: 'clock',
    url: 'assets/ui-lib/icons/clock.svg',
  },
  {
    name: 'camera',
    url: 'assets/ui-lib/icons/camera.svg',
  },
  {
    name: 'cog',
    url: 'assets/ui-lib/icons/cog.svg',
  },
  {
    name: 'close',
    url: 'assets/ui-lib/icons/close.svg',
  },
  {
    name: 'like',
    url: 'assets/ui-lib/icons/like.svg',
  },
  { name: 'play', url: 'assets/ui-lib/icons/play.svg' },
  { name: 'play_narrow', url: 'assets/ui-lib/icons/play_narrow.svg' },
  { name: 'user', url: 'assets/ui-lib/icons/user.svg' },
  { name: 'user-x', url: 'assets/ui-lib/icons/user-x.svg' },
  { name: 'transparent', url: 'assets/ui-lib/icons/transparent.svg' },
  { name: 'refresh', url: 'assets/ui-lib/icons/refresh.svg' },
  { name: 'file-chart-bar', url: 'assets/ui-lib/icons/file-chart-bar.svg' },
  {
    name: 'chart-mixed-dollar',
    url: 'assets/ui-lib/icons/chart-mixed-dollar.svg',
  },
  { name: 'user-circle', url: 'assets/ui-lib/icons/user-circle.svg' },
  {
    name: 'file-search-outline',
    url: 'assets/ui-lib/icons/file-search-outline.svg',
  },
  {
    name: 'file-circle-plus-outline',
    url: 'assets/ui-lib/icons/file-circle-plus-outline.svg',
  },
  { name: 'heart-outline', url: 'assets/ui-lib/icons/heart-outline.svg' },
  { name: 'heart', url: 'assets/ui-lib/icons/heart.svg' },
  { name: 'chevron-right', url: 'assets/ui-lib/icons/chevron-right.svg' },
  {
    name: 'chevron-double-right',
    url: 'assets/ui-lib/icons/chevron-double-right.svg',
  },
  { name: 'file-lines', url: 'assets/ui-lib/icons/file-lines.svg' },
  { name: 'envelope', url: 'assets/ui-lib/icons/envelope.svg' },
  { name: 'dots-horizontal', url: 'assets/ui-lib/icons/dots-horizontal.svg' },
  { name: 'calendar-week', url: 'assets/ui-lib/icons/calendar-week.svg' },
  {
    name: 'file-invoice-outline',
    url: 'assets/ui-lib/icons/file-invoice-outline.svg',
  },
  {
    name: 'arrow-up-from-bracket',
    url: 'assets/ui-lib/icons/arrow-up-from-bracket.svg',
  },
  { name: 'teacher', url: 'assets/ui-lib/icons/teacher.svg' },
  {
    name: 'flask-conical-outline',
    url: 'assets/ui-lib/icons/flask-conical-outline.svg',
  },
  {
    name: 'briefcase-medical-outline',
    url: 'assets/ui-lib/icons/briefcase-medical-outline.svg',
  },
  { name: 'file-pdf', url: 'assets/ui-lib/icons/file-pdf.svg' },
  { name: 'file', url: 'assets/ui-lib/icons/file.svg' },
  {
    name: 'circle-plus-outline',
    url: 'assets/ui-lib/icons/circle-plus-outline.svg',
  },
  {
    name: 'check-circle-outline',
    url: 'assets/ui-lib/icons/check-circle-outline.svg',
  },
  {
    name: 'close-circle-outline',
    url: 'assets/ui-lib/icons/close-circle-outline.svg',
  },
  {
    name: 'calendar-cancel-outline',
    url: 'assets/ui-lib/icons/calendar-cancel-outline.svg',
  },
  { name: 'stethoscope', url: 'assets/ui-lib/icons/stethoscope.svg' },
  { name: 'activity', url: 'assets/ui-lib/icons/activity.svg' },
  { name: 'pill-outline', url: 'assets/ui-lib/icons/pill-outline.svg' },
  {
    name: 'calendar-day-outline',
    url: 'assets/ui-lib/icons/calendar-day-outline.svg',
  },
  {
    name: 'calendar-check-outline',
    url: 'assets/ui-lib/icons/calendar-check-outline.svg',
  },
  { name: 'list-check', url: 'assets/ui-lib/icons/list-check.svg' },
  { name: 'dumbbell-outline', url: 'assets/ui-lib/icons/dumbbell-outline.svg' },
  { name: 'salad-outline', url: 'assets/ui-lib/icons/salad-outline.svg' },
  { name: 'save-outline', url: 'assets/ui-lib/icons/save-outline.svg' },
  { name: 'atom', url: 'assets/ui-lib/icons/atom.svg' },
  { name: 'search-outline', url: 'assets/ui-lib/icons/search-outline.svg' },
  {
    name: 'test-tube-diagonal-outline',
    url: 'assets/ui-lib/icons/test-tube-diagonal-outline.svg',
  },
  {
    name: 'download-outline',
    url: 'assets/ui-lib/icons/download-outline.svg',
  },
  { name: 'printer-outline', url: 'assets/ui-lib/icons/printer-outline.svg' },
  {
    name: 'file-text-outline',
    url: 'assets/ui-lib/icons/file-text-outline.svg',
  },
  {
    name: 'arrow-down-to-bracket',
    url: 'assets/ui-lib/icons/arrow-down-to-bracket.svg',
  },
  { name: 'zoom-in-outline', url: 'assets/ui-lib/icons/zoom-in-outline.svg' },
  { name: 'zoom-out-outline', url: 'assets/ui-lib/icons/zoom-out-outline.svg' },
  {
    name: 'paper-plane-outline',
    url: 'assets/ui-lib/icons/paper-plane-outline.svg',
  },
  {
    name: 'messages-outline',
    url: 'assets/ui-lib/icons/messages-outline.svg',
  },
  {
    name: 'lock-time-outline',
    url: 'assets/ui-lib/icons/lock-time-outline.svg',
  },
  {
    name: 'messages-fixed',
    url: 'assets/ui-lib/icons/messages-fixed.svg',
    colorMode: 'fixed',
  },
  {
    name: 'microphone-outline',
    url: 'assets/ui-lib/icons/microphone-outline.svg',
  },
  {
    name: 'info',
    url: 'assets/ui-lib/icons/info.svg',
  },
  {
    name: 'info-solid',
    url: 'assets/ui-lib/icons/info-solid.svg',
  },
  {
    name: 'bell-active',
    url: 'assets/ui-lib/icons/bell-active.svg',
  },
  {
    name: 'calendar-plus-2',
    url: 'assets/ui-lib/icons/calendar-plus-2.svg',
  },
  {
    name: 'file-plus',
    url: 'assets/ui-lib/icons/file-plus.svg',
  },
  {
    name: 'videocamera',
    url: 'assets/ui-lib/icons/videocamera.svg',
  },
  {
    name: 'screen-share',
    url: 'assets/ui-lib/icons/screen-share.svg',
  },
  {
    name: 'phone-off',
    url: 'assets/ui-lib/icons/phone-off.svg',
  },
  {
    name: 'phone',
    url: 'assets/ui-lib/icons/phone.svg',
  },
  {
    name: 'phone-outline',
    url: 'assets/ui-lib/icons/phone-outline.svg',
  },
  {
    name: 'phone-solid',
    url: 'assets/ui-lib/icons/phone-solid.svg',
  },
  {
    name: 'phone-handset-outline',
    url: 'assets/ui-lib/icons/phone-handset-outline.svg',
  },
  {
    name: 'bars',
    url: 'assets/ui-lib/icons/bars.svg',
  },
  {
    name: 'telehealth-to-mini',
    url: 'assets/ui-lib/icons/telehealth-to-mini.svg',
  },
  {
    name: 'telehealth-to-side',
    url: 'assets/ui-lib/icons/telehealth-to-side.svg',
  },
  {
    name: 'telehealth-expand',
    url: 'assets/ui-lib/icons/telehealth-expand.svg',
  },
  {
    name: 'telehealth-collapse',
    url: 'assets/ui-lib/icons/telehealth-collapse.svg',
  },
  {
    name: 'telehealth-camera',
    url: 'assets/ui-lib/icons/telehealth-camera.svg',
  },
  {
    name: 'telehealth-microphone',
    url: 'assets/ui-lib/icons/telehealth-microphone.svg',
  },
  {
    name: 'telehealth-settings',
    url: 'assets/ui-lib/icons/telehealth-settings.svg',
  },
  {
    name: 'telehealth-screen-share',
    url: 'assets/ui-lib/icons/telehealth-screen-share.svg',
  },
  {
    name: 'pencil',
    url: 'assets/ui-lib/icons/pencil.svg',
  },
  {
    name: 'calendar-sync-outline',
    url: 'assets/ui-lib/icons/calendar-sync-outline.svg',
    colorMode: 'fixed',
  },
  {
    name: 'x-outline',
    url: 'assets/ui-lib/icons/x-outline.svg',
    colorMode: 'fixed',
  },
  {
    name: 'bell',
    url: 'assets/ui-lib/icons/bell.svg',
  },
  {
    name: 'calendar-clock',
    url: 'assets/ui-lib/icons/calendar-clock.svg',
  },
  {
    name: 'no-appointments-icon',
    url: 'assets/ui-lib/icons/no-appointments-icon.svg',
    colorMode: 'fixed',
  },
  {
    name: 'telehealth-waiting',
    url: 'assets/ui-lib/icons/telehealth-waiting.svg',
    colorMode: 'fixed',
  },
  {
    name: 'dots-vertical',
    url: 'assets/ui-lib/icons/dots-vertical.svg',
  },
  {
    name: 'pencil_2-outline',
    url: 'assets/ui-lib/icons/pencil_2-outline.svg',
    colorMode: 'fixed',
  },
  {
    name: 'check',
    url: 'assets/ui-lib/icons/check.svg',
  },
  {
    name: 'symptom-dash',
    url: 'assets/ui-lib/icons/symptom-dash.svg',
  },
  {
    name: 'file-pen-outline',
    url: 'assets/ui-lib/icons/file-pen-outline.svg',
  },
  {
    name: 'pen-nib-outline',
    url: 'assets/ui-lib/icons/pen-nib-outline.svg',
  },
  {
    name: 'chevron-down',
    url: 'assets/ui-lib/icons/chevron-down.svg',
  },
  {
    name: 'pen',
    url: 'assets/ui-lib/icons/pen.svg',
  },
  {
    name: 'file-lines-outline',
    url: 'assets/ui-lib/icons/file-lines-outline.svg',
  },
  {
    name: 'plus-outline',
    url: 'assets/ui-lib/icons/plus-outline.svg',
  },
  {
    name: 'medications-outline',
    url: 'assets/ui-lib/icons/medications-outline.svg',
  },
  {
    name: 'supplements-outline',
    url: 'assets/ui-lib/icons/supplements-outline.svg',
  },
  {
    name: 'medications-empty',
    url: 'assets/ui-lib/icons/medications-empty.svg',
    colorMode: 'fixed',
  },
  {
    name: 'calendar-day',
    url: 'assets/ui-lib/icons/calendar-day.svg',
  },
  {
    name: 'patinet-symptoms-empty',
    url: 'assets/ui-lib/icons/patinet-symptoms-empty.svg',
    colorMode: 'fixed',
  },
  {
    name: 'supplements-empty',
    url: 'assets/ui-lib/icons/supplements-empty.svg',
    colorMode: 'fixed',
  },
  {
    name: 'goals-empty',
    url: 'assets/ui-lib/icons/goals-empty.svg',
    colorMode: 'fixed',
  },
  {
    name: 'flag-outline',
    url: 'assets/ui-lib/icons/flag-outline.svg',
  },
  {
    name: 'functional-medicine',
    url: 'assets/ui-lib/icons/functional-medicine.svg',
  },
  {
    name: 'functional-medicine-empty',
    url: 'assets/ui-lib/icons/functional-medicine-empty.svg',
    colorMode: 'fixed',
  },
  {
    name: 'protocols-empty',
    url: 'assets/ui-lib/icons/protocols-empty.svg',
    colorMode: 'fixed',
  },
  {
    name: 'sparkles',
    url: 'assets/ui-lib/icons/sparkles.svg',
  },
  {
    name: 'forms-empty',
    url: 'assets/ui-lib/icons/forms-empty.svg',
    colorMode: 'fixed',
  },
  {
    name: 'receipt-outline',
    url: 'assets/ui-lib/icons/receipt-outline.svg',
  },
  {
    name: 'wand-magic-sparkles',
    url: 'assets/ui-lib/icons/wand-magic-sparkles.svg',
  },
  {
    name: 'wand-magic-outline',
    url: 'assets/ui-lib/icons/wand-magic-outline.svg',
  },
  {
    name: 'user-circle-fixed',
    url: 'assets/ui-lib/icons/user-circle-fixed.svg',
    colorMode: 'fixed',
  },
  {
    name: 'completed',
    url: 'assets/ui-lib/icons/completed.svg',
  },
  {
    name: 'shield-warning',
    url: 'assets/ui-lib/icons/shield-warning.svg',
  },
  {
    name: 'earth',
    url: 'assets/ui-lib/icons/earth.svg',
  },
  {
    name: 'history',
    url: 'assets/ui-lib/icons/history.svg',
  },
  {
    name: 'lock',
    url: 'assets/ui-lib/icons/lock.svg',
  },
  {
    name: 'undo-outline',
    url: 'assets/ui-lib/icons/undo-outline.svg',
  },
  {
    name: 'support',
    url: 'assets/ui-lib/icons/support-icon.svg',
  },
  {
    name: 'circle-user-round',
    url: 'assets/ui-lib/icons/circle-user-round.svg',
  },
  {
    name: 'void-payment',
    url: 'assets/ui-lib/icons/void-payment.svg',
  },
  {
    name: 'visa-payment',
    url: 'assets/ui-lib/icons/visa-payment.svg',
    colorMode: 'fixed',
  },
  {
    name: 'mastercard-payment',
    url: 'assets/ui-lib/icons/mastercard-payment.svg',
    colorMode: 'fixed',
  },
  {
    name: 'bank-payment',
    url: 'assets/ui-lib/icons/bank-payment.svg',
  },
  {
    name: 'copy',
    url: 'assets/ui-lib/icons/copy.svg',
  },
  {
    name: 'link-payment',
    url: 'assets/ui-lib/icons/link-payment.svg',
  },
  {
    name: 'brain',
    url: 'assets/ui-lib/icons/brain.svg',
    colorMode: 'fixed',
  },
  {
    name: 'clipboard-tasks',
    url: 'assets/ui-lib/icons/clipboard-tasks.svg',
    colorMode: 'fixed',
  },
  {
    name: 'microscope',
    url: 'assets/ui-lib/icons/microscope.svg',
    colorMode: 'fixed',
  },
  {
    name: 'search-blue',
    url: 'assets/ui-lib/icons/search-blue.svg',
    colorMode: 'fixed',
  },
  {
    name: 'expand',
    url: 'assets/ui-lib/icons/expand.svg',
  },
  {
    name: 'users',
    url: 'assets/ui-lib/icons/users.svg',
  },
  {
    name: 'list',
    url: 'assets/ui-lib/icons/list.svg',
  },
  {
    name: 'collapse',
    url: 'assets/ui-lib/icons/collapse.svg',
  },
  {
    name: 'photo',
    url: 'assets/ui-lib/icons/photo.svg',
  },
  {
    name: 'circle-minus',
    url: 'assets/ui-lib/icons/circle-minus.svg',
  },
  {
    name: 'book-education',
    url: 'assets/ui-lib/icons/book-education.svg',
    colorMode: 'fixed',
  },
  {
    name: 'provider-landing-icon-reference',
    url: 'assets/ui-lib/icons/provider-landing-icon-reference.svg',
  },
  {
    name: 'trending-up',
    url: 'assets/ui-lib/icons/trending-up.svg',
  },
  {
    name: 'megaphone',
    url: 'assets/ui-lib/icons/megaphone.svg',
  },
  {
    name: 'user-plus',
    url: 'assets/ui-lib/icons/user-plus.svg',
  },
  {
    name: 'document-text',
    url: 'assets/ui-lib/icons/document-text.svg',
  },
  {
    name: 'meal-plan',
    url: 'assets/ui-lib/icons/meal-plan.svg',
  },
  {
    name: 'message-unread',
    url: 'assets/ui-lib/icons/message-unread.svg',
  },
  {
    name: 'question-circle-outline',
    url: 'assets/ui-lib/icons/question-circle-outline.svg',
  },
  {
    name: 'adjustments-vertical-outline',
    url: 'assets/ui-lib/icons/adjustments-vertical-outline.svg',
  },
  {
    name: 'globe-outline',
    url: 'assets/ui-lib/icons/globe-outline.svg',
  },
  {
    name: 'appointment-status-upcoming',
    url: 'assets/ui-lib/icons/appointment-status-upcoming.svg',
    colorMode: 'fixed',
  },
  {
    name: 'appointment-status-completed',
    url: 'assets/ui-lib/icons/appointment-status-completed.svg',
    colorMode: 'fixed',
  },
  {
    name: 'appointment-status-no-show',
    url: 'assets/ui-lib/icons/appointment-status-no-show.svg',
    colorMode: 'fixed',
  },
  {
    name: 'appointment-status-awaiting-outcome',
    url: 'assets/ui-lib/icons/appointment-status-awaiting-outcome.svg',
    colorMode: 'fixed',
  },
  {
    name: 'download-tray',
    url: 'assets/ui-lib/icons/download-tray.svg',
    colorMode: 'fixed',
  },
  {
    name: 'marketing-newsletter',
    url: 'assets/ui-lib/icons/marketing-newsletter.svg',
  },
  {
    name: 'marketing-follow-up',
    url: 'assets/ui-lib/icons/marketing-follow-up.svg',
  },
  {
    name: 'marketing-birthday',
    url: 'assets/ui-lib/icons/marketing-birthday.svg',
  },
  {
    name: 'document-outline',
    url: 'assets/ui-lib/icons/document-outline.svg',
  },
  { name: 'sparkles-two', url: 'assets/ui-lib/icons/sparkles-two.svg' },
  { name: 'clipboard-check', url: 'assets/ui-lib/icons/clipboard-check.svg' },
];

@NgModule()
export class ExternalSvgModule {
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);

  constructor() {
    this.registerIcons();
  }

  private registerIcons(): void {
    iconDefinitions.forEach(icon => {
      this.iconRegistry.addSvgIcon(icon.name, this.setPath(icon.url));
    });
  }

  private setPath(url: string): SafeResourceUrl {
    // Every URL comes from the static iconDefinitions allowlist above.
    // nosemgrep: typescript.angular.security.audit.angular-domsanitizer.angular-bypasssecuritytrust
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
